import React, { Component } from 'react';
import './App.scss';

import Nav from './Nav';
import Story from './Story';
import STORIES from './Story.const';

import headerTitle from './assets/images/header_title.png';
import headerImage from './assets/images/headerimage.jpg';
import playButton from './assets/images/top_playbutton.jpg';
import pauseButton from './assets/images/top_pausebutton.jpg';

if(window.location.pathname.substr(-1) == '/'){
	var root = window.location.pathname;
}else{
	var root = window.location.pathname+'/';
}
export const APP_ROOT_PATH = root;
//export const APP_ROOT_PATH = '/theheartseekers/';

class App extends Component {
  constructor(props) {
    super(props);

    const language = this.getLanguage();

    this.state = {
      language,
      activeAudioIndex: undefined
    };

    if (!language === '' || !this.isValidLanguage(language)) {
      window.location.href = `${APP_ROOT_PATH}/zh-HK`;
      return;
    }

    this.players = [];
    for (const _ of STORIES) {
      this.players.push(undefined);
    }
  }

  getLanguage = () => {
    let language = 'zh-HK';
    const { match } = this.props;
    /*if (match && match.params && match.params.language) {
      language = match.params.language;
    }*/
	if (match && match.url && match.url.split("/").pop() == 'en') {
      language = 'en';
    }else if (match && match.url && match.url.split("/").pop() == 'zh-hk') {
	  language = 'zh-HK';
	}
    return language;
  };

  isValidLanguage = language => {
    return ['en', 'zh-HK'].includes(language);
  };

  handlePlayClick = index => {
    const { players, pausePlayer } = this;
    const { activeAudioIndex } = this.state;

    if (activeAudioIndex !== undefined) {
      // pause playing audio
      pausePlayer(activeAudioIndex);
    }

    if (activeAudioIndex !== index) {
      // play selected audio
      let newPlayer = players[index];
      if (!newPlayer) {
        const soundTrack =
          this.getLanguage() === 'en'
            ? STORIES[index].soundTrackEN
            : STORIES[index].soundTrack;
        newPlayer = new Audio(soundTrack);
        newPlayer.addEventListener('ended', () => {
          this.setState({ activeAudioIndex: undefined });
        });
        players[index] = newPlayer;
      }
      newPlayer.play();
      this.setState({ activeAudioIndex: index });
    } else {
      // pause current audio
      this.setState({ activeAudioIndex: undefined });
    }
  };

  handlePlayIntroductionClick = () => {
    this.handlePlayClick(0);
  };

  pausePlayer = index => {
    const { players } = this;
    const oldPlayer = players[index];
    oldPlayer && oldPlayer.pause();
  };

  render() {
    const { handlePlayClick, handlePlayIntroductionClick } = this;
    const { language, activeAudioIndex } = this.state;

    return (
      <div className="wrapper">
        <Nav language={language}/>
        <header className="page-header">
		 <>
			<img src={headerImage} alt="SEE YOU MEMORIES"/>
			 </>
        </header>
        <section className="description">
          {language !== 'en' && (
            <>
              <p>
              903節目主持及填詞人 Oscar 編寫的漫畫廣播劇《回憶見：後續》，延續漫畫未完的故事，其中充滿起伏、懸疑及情感。Oscar 親自聲演男主角張伯樂，而女主角李蜜兒則由特別合作的 Sandy @per se 聲演。
<br/><br/>
張伯樂與李蜜兒在現實世界重遇後的半年後，他們的日子平淡普通，生活不如在無人的逆時世界之中那麼浪漫幸福。
<br/><br/>
直至一天，有神秘人把一幅禁畫寄到畫廊，潘朵拉的盒子再次打開⋯⋯
<br/><br/>
<b>如果有重新開始的機會，你會重新開始嗎？</b>
</p>
            </>
          )}
          {language == 'en' && (
            <>
               <p>
              "SEE YOU MEMORIES" is divided into two parts: In addition to the Hong Kong part curated by Ztory Teller, "SEE YOU MEMORIES" will be also held in Krakow, Poland at the end of August, curated by artist @mateusz_kolek - through the bi-city exhibition in different places, there is no obstacle to connect Hong Kong and Poland through art.
</p>
              <p>
From conception to implementation, it was a long journey. Finally, with the collection of works on the website, the exhibition will officially start this Sunday, August 14th.
</p>
              <p>
Mateusz's first solo collection "Alone Together", with the theme of Hong Kong, Japan and Poland, records the appearance of the world before and after the change.
</p>
            </>
          )}
        </section>
        <section className="journey">
          <h2>Start Imagining</h2>
          <div className="stories">
            {STORIES.map((story, index) => {
              const { title, subTitle, imageSrc, desc, descEN } = story;

              return (
                <Story
                  key={index}
                  index={index}
                  title={title}
                  subTitle={subTitle}
                  desc={this.getLanguage()=='en'?descEN:desc}
                  imageSrc={imageSrc}
                  onPlayClick={handlePlayClick}
                  isPlaying={activeAudioIndex === index}
                />
              );
            })}
          </div>
		  <section class="description">
		  </section>
		  {language !== 'en' && (
		 <>
		  <div className="thanks">《回憶見：後續》漫畫廣播劇<br/>
<br/>
編劇及製作： Oscar<br/>
聲演： Oscar、Sandy @per se<br/>
插畫：Pen So<br/>
<br/>
</div>
<hr/>
<div className="thanks">
<br/>
Oscar 李文曦<br/>
<br/>
香港商業電台叱咤903唱片騎師及填詞人， 現時主持節目《失眠藥》及《夜間失格》。由2014年起，填詞作品至今累積超過百首。出版散文及插畫集作品包括《夜間遊牧01 - 虛構夜誌》、《夜間遊牧02 - 一起一個人》、《想像記憶集合體》、《夜間遊牧03 - 日常風物詩》（2023年7月推出）。<br/>
<br/>
Instagram: @oscarlee
</div>
		  </>
		 )}
		 {language == 'en' && (
            <>
		  <div className="thanks">Audio guide performed by Sabrina Cheung</div>
		  </>
		  )}
		  <br/>
		  <div class="vertical-border"></div>
		  <a href="/TheWanderer/" className="readmore">收聽畫作故事</a>
        </section>
      </div>
    );
  }
}

export default App;
